import { useState } from "react";
import { ax, formatApiErrorDetail } from "../../lib/adminApi";

const googleSignIn = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/admin";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15A11 11 0 0 0 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z" />
  </svg>
);

const Field = ({ type, value, onChange, placeholder, testid }) => (
  <input
    type={type}
    required
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    data-testid={testid}
    className="h-14 w-full rounded-2xl border border-forest/15 bg-mist px-5 text-sm text-forest outline-none placeholder:text-forest/40 focus:ring-2 focus:ring-fresh"
  />
);

const OrDivider = () => (
  <div className="flex items-center gap-3 py-1">
    <span className="h-px flex-1 bg-forest/10" />
    <span className="text-xs font-bold uppercase tracking-[0.15em] text-forest/40">or</span>
    <span className="h-px flex-1 bg-forest/10" />
  </div>
);

export const AdminLoginCard = ({ onSuccess }) => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await ax.post("/auth/login", form);
      onSuccess(data);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-mist px-6 font-manrope">
      <form
        onSubmit={login}
        data-testid="admin-login-form"
        className="w-full max-w-md rounded-[2rem] border border-forest/10 bg-white p-10 shadow-xl"
      >
        <p className="font-syne text-2xl font-extrabold text-forest">
          Freshly<span className="text-fresh">.</span>
        </p>
        <h1 className="mt-6 font-syne text-3xl font-extrabold tracking-tight text-forest">
          Admin sign in
        </h1>
        <p className="mt-2 text-sm text-forest/60">Leads and fleet applications, in one place.</p>
        <div className="mt-8 space-y-4">
          <Field
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder="Email"
            testid="admin-login-email"
          />
          <Field
            type="password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            placeholder="Password"
            testid="admin-login-password"
          />
          {error && (
            <p data-testid="admin-login-error" className="text-sm font-semibold text-red-600">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="h-14 w-full rounded-2xl bg-forest font-manrope text-sm font-bold text-bone transition-colors hover:bg-fresh disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <OrDivider />
          <button
            type="button"
            onClick={googleSignIn}
            data-testid="admin-google-signin"
            className="flex h-14 w-full items-center justify-center gap-3 rounded-2xl border border-forest/15 bg-white font-manrope text-sm font-bold text-forest transition-colors hover:border-fresh"
          >
            <GoogleIcon />
            Sign in with Google
          </button>
        </div>
      </form>
    </div>
  );
};
